import { formatDate } from "@utils/DateUtils";
import { FormatPattern } from "@enums";
import { useDatePickerContext } from "@contexts/DatePickerContext";
import { useUtcContext } from "@contexts/UtcContext";
export const useDeIceDateSelector = () => {
    const { utc } = useUtcContext();
    const { picker: { from }, } = useDatePickerContext();
    return formatDate(utc, from, FormatPattern.yyyy_MM_dd);
};
